import React, { useState } from 'react'
import { DRIVER_PHOTOS } from '../driverPhotos'

interface Props {
  name: string
  number: number
  color?: string
  size?: number
}

export default function DriverAvatar({ name, number, color = '#3182ce', size = 38 }: Props) {
  const [failed, setFailed] = useState(false)
  const src = DRIVER_PHOTOS[number]

  const base: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    flexShrink: 0,
    border: `2px solid ${color}`,
  }

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name}
        style={{ ...base, objectFit: 'cover', objectPosition: 'top center', background: '#0d2e5c' }}
        onError={() => setFailed(true)}
      />
    )
  }

  return (
    <div
      style={{
        ...base,
        background: `linear-gradient(135deg, ${color}dd, ${color}77)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 800,
        fontSize: size * 0.36,
        color: '#fff',
        letterSpacing: '-0.5px',
        fontFamily: 'Montserrat, sans-serif',
      }}
    >
      {number}
    </div>
  )
}
